export default __webpack_public_path__ + "static/media/SD-gallery-01.99bade47.png";